import { useRef, useState } from 'react';
import { Field } from 'redux-form';
import {getRaisonSocialeBySiren, getTranslation, listFormeJuridique, normalizeDecimal} from '../../../utils';
import { Select, Text } from '../../forms';

export const InformationEntreprise = (props) => {
    const { changeValue, needAdresse = false, isDejaClient = false } = props;
    const [isFirstFetch, setIsFirstFetch] = useState(true);
    const [loadingSIREN, setLoadingSIREN] = useState(false);
    const [errorSIREN, setErrorSIREN] = useState(false);
    const [needManualReason, setNeedManualReason] = useState(false); // [TODO] : needManualReason is always false, so the following condition is always false too : !_.get(props.data, 'DemandeTarif[ListePersonnes][1][Nom]') && errorSIREN
    const inputSIREN = useRef(null);

    const fetchGetSociety = async (value) => {
        setLoadingSIREN(true);

        try {
            let society = await getRaisonSocialeBySiren(value);
            changeValue('DemandeTarif[ListePersonnes][1][Nom]', society.denomination);

            if (needAdresse) {
                const adresse = society.adresse

                // adresse
                changeValue('DemandeTarif[ListePersonnes][0][Adresse1]', (adresse?.numVoie + ' ' + adresse?.typeVoie + ' ' + adresse?.voie ).replace('undefined', '').trim());
                changeValue('DemandeTarif[ListePersonnes][0][Adresse2]', '');
                changeValue('DemandeTarif[ListePersonnes][0][Adresse3]', '');
                changeValue('DemandeTarif[ListePersonnes][0][CP]', adresse.codePostal);
                changeValue('DemandeTarif[ListePersonnes][0][Ville]', adresse.commune);

            }

            setErrorSIREN(false);
        } catch (e) {
            if (e.response.status === 500) {
                setNeedManualReason(true);
            } else {
                setErrorSIREN(e.response.data.message);
            }
        }

        setIsFirstFetch(false)
        setLoadingSIREN(false);
    };
    
    const whenSIRENChange = () => {
        changeValue('DemandeTarif[ListePersonnes][1][Nom]', '');
        if (needAdresse) {
            // adresse
            changeValue('DemandeTarif[ListePersonnes][0][Adresse1]', '');
            changeValue('DemandeTarif[ListePersonnes][0][Adresse2]', '');
            changeValue('DemandeTarif[ListePersonnes][0][Adresse3]', '');
            changeValue('DemandeTarif[ListePersonnes][0][CP]', '');
            changeValue('DemandeTarif[ListePersonnes][0][Ville]', '');
        }
        setIsFirstFetch(true);
    }

    return (
        <>
            <div className={'row justify-content-center'}>
                <div className={'col-lg-8 col-md-6 col-sm-6 col-12 my-2'}>
                    <Field
                        label={getTranslation('informationsSubscriptor.idSociety')}
                        component={Text}
                        type={'tel'}
                        name={'DemandeTarif[ListePersonnes][1][IdSociety]'}
                        normalize={normalizeDecimal}
                        onChange={whenSIRENChange}
                        ref={inputSIREN}
                        disabled={isDejaClient}
                        required
                    />

                    {errorSIREN && (
                        <div className={'alert-danger alert mb-0'}>
                            {errorSIREN}
                        </div>
                    )}

                    {needManualReason && (
                        <div className={'alert-danger alert mb-0'}>
                            {getTranslation('informationsSubscriptor.alertINPI')}
                        </div>
                    )}

                    {(!errorSIREN && !isFirstFetch) && (
                        <div className={'alert-success alert mb-0'}>
                            {getTranslation('informationsSubscriptor.alertSuccessINPI')}
                        </div>
                    )}

                    {!isDejaClient &&  (
                        <span
                            className="btn btn-secondary btn-smaller mt-2"
                            onClick={() => fetchGetSociety(inputSIREN.current.value)}
                        >
                            {loadingSIREN ? (
                                <div className="spinner-border" role="status" style={{ width: 19, height: 19 }}>
                                    <span className="sr-only" />
                                </div>
                            ) : (
                                getTranslation('informationsSubscriptor.iConfirmIdSociety')
                            )}
                        </span>
                    )}
                </div>
            </div>

            <div className={'row justify-content-center'}>
                <div className={'col-lg-8 col-md-6 col-sm-6 col-12 my-2'}>
                    <Field
                        name={`DemandeTarif[ListePersonnes][1][Nom]`}
                        label={getTranslation('informationsSubscriptor.companyName')}
                        component={Text}
                        type={'text'}
                        disabled={isDejaClient}
                        required
                    />
                </div>
            </div>

            <div className={'row justify-content-center'}>
                <div className={'col-lg-8 col-md-6 col-sm-6 col-12 my-2'}>
                    <Field
                        label={getTranslation('informationsSubscriptor.legalStatus')}
                        name={'DemandeTarif[ListePersonnes][1][LegalStatus]'}
                        component={Select}
                        onChange={() => changeValue('DemandeTarif[ListePersonnes][1][LegalStatus]', '')}
                        disabled={isDejaClient}
                        required
                    >
                        <option value={''}>{getTranslation('informationsSubscriptor.selectLegalStatus')}</option>
                        {listFormeJuridique.map((item, index) => {
                            return (
                                <option key={index} value={item.id}>
                                    {item.name}
                                </option>
                            );
                        })}
                    </Field>
                </div>
            </div>
        </>
    );
};
